import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { changePassword as _changePassword } from '@/api/user';
import { getValidateCodeMsg, checkPassword } from '@/utils/validate';
export default {
  name: 'ChangePasswordModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;
    return {
      loading: false,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        googleCode: ''
      },
      rules: {
        oldPassword: {
          validate: function validate(val) {
            if (!val) {
              return _this.$t('changePassword.oldPasswordRequired');
            }
            return '';
          }
        },
        newPassword: {
          validate: function validate(val) {
            if (!val) {
              return _this.$t('changePassword.newPasswordRequired');
            }
            if (val.length < 6) {
              return _this.$t('changePassword.passwordMinLength');
            }
            if (val === _this.form.oldPassword) {
              return _this.$t('changePassword.newPasswordDifferent');
            }
            return '';
          }
        },
        confirmPassword: {
          validate: function validate(val) {
            if (!val) {
              return _this.$t('changePassword.confirmPasswordRequired');
            }
            if (val !== _this.form.newPassword) {
              return _this.$t('changePassword.passwordMismatch');
            }
            return '';
          }
        },
        googleCode: {
          validate: getValidateCodeMsg
        }
      }
    };
  },
  computed: {
    // 移除visible计算属性，直接使用props
  },
  watch: {
    visible: function visible(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },
    'form.newPassword': function formNewPassword() {
      // 当新密码改变时，重新验证确认密码
      if (this.$refs.changePasswordForm) {
        this.$refs.changePasswordForm.validateField('confirmPassword');
      }
    },
    'form.oldPassword': function formOldPassword() {
      // 当原密码改变时，重新验证新密码
      if (this.$refs.changePasswordForm) {
        this.$refs.changePasswordForm.validateField('newPassword');
      }
    }
  },
  methods: {
    resetForm: function resetForm() {
      this.form = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        googleCode: ''
      };
      // 重置表单验证状态
      if (this.$refs.changePasswordForm) {
        this.$refs.changePasswordForm.resetFields();
      }
    },
    handleSubmit: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isValid;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$refs.changePasswordForm.validate();
            case 3:
              isValid = _context.sent;
              if (isValid) {
                _context.next = 7;
                break;
              }
              console.log('Validation failed');
              return _context.abrupt("return");
            case 7:
              this.loading = true;
              // 这里调用修改密码的API
              _context.next = 10;
              return this.changePassword();
            case 10:
              this.$message.success(this.$t('changePassword.success'));
              this.$emit('update:visible', false);
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              if (_context.t0.message) {
                this.$message.error(_context.t0.message || this.$t('changePassword.failed'));
              }
            case 17:
              _context.prev = 17;
              this.loading = false;
              return _context.finish(17);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 14, 17, 20]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    changePassword: function () {
      var _changePassword2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                old_password: this.form.oldPassword,
                new_password: this.form.newPassword
              };
              return _context2.abrupt("return", _changePassword(data, this.form.googleCode));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function changePassword() {
        return _changePassword2.apply(this, arguments);
      }
      return changePassword;
    }()
  }
};